/* eslint-disable */
import htkv from "../api/htexKonvaTransformHT.js";
import Konva from "konva";
export default {
  //比較大的改動直接叫舊版的函式
  async renderAllToStage(vm) {
    let that = vm;

    if (vm.mobileirs.msgLayerInfo != "") {
      vm.hostStageWidth = typeof vm.mobileirs.msgLayerInfo === "string" ? JSON.parse(vm.mobileirs.msgLayerInfo).width : vm.mobileirs.msgLayerInfo.width;
      vm.hostStageHeight = typeof vm.mobileirs.msgLayerInfo === "string" ? JSON.parse(vm.mobileirs.msgLayerInfo).height : vm.mobileirs.msgLayerInfo.height;

      vm.relativScaleRatio = typeof vm.mobileirs.msgLayerInfo === "string" ? vm.calScaleRatio(vm.hostStageWidth, vm.hostStageHeight, window.innerWidth, window.innerHeight) : vm.relativScaleRatio;
      console.log(vm.hostStageWidth, vm.hostStageHeight, "vm.blobSas_read");

      //重置coworkBgRatio
      vm.coworkBgRatio = vm.calScaleRatio(vm.hostStageWidth, vm.hostStageHeight, window.innerWidth, window.innerHeight).ratio;

      let JsonInfo = typeof vm.mobileirs.msgLayerInfo === "string" ? JSON.parse(vm.mobileirs.msgLayerInfo).children : vm.mobileirs.msgLayerInfo.children;
      let KonvaItem;

      for (const key in JsonInfo) {
        let JsonItem = typeof JsonInfo[key] === "string" ? JSON.parse(JsonInfo[key]) : JsonInfo[key];

        let normalClassName = ["Line", "Circle", "Rect", "Star", "Text", "Path", "Ellipse", "RegularPolygon"];

        normalClassName.forEach((className) => {
          if (JsonItem.className == className) {
            KonvaItem = new Konva[className](JsonItem.attrs);
            KonvaItem.setAttrs({
              index: parseInt(key),
            });
            //Cowork縮放
            KonvaItem.x(KonvaItem.x() * that.coworkBgRatio);
            KonvaItem.y(KonvaItem.y() * that.coworkBgRatio);
            KonvaItem.scaleX(KonvaItem.scaleX() * that.coworkBgRatio);
            KonvaItem.scaleY(KonvaItem.scaleY() * that.coworkBgRatio);
          }
        });

        if (JsonItem.className == "Label" && JsonItem.attrs?.name != "namelabel") {
          //文字便利貼
          let label = new Konva.Label(JsonItem.attrs);
          label.setAttrs({
            index: parseInt(key),
          });
          //Cowork縮放
          label.x(label.x() * that.coworkBgRatio);
          label.y(label.y() * that.coworkBgRatio);
          label.scaleX(label.scaleX() * that.coworkBgRatio);
          label.scaleY(label.scaleY() * that.coworkBgRatio);

          JsonItem.children.forEach((item) => {
            if (item.className == "Tag") {
              let tag = new Konva.Tag(item.attrs);
              tag.x(tag.x() * that.coworkBgRatio);
              tag.y(tag.y() * that.coworkBgRatio);
              label.add(tag);
            }
            if (item.className == "Text") {
              let text = new Konva.Text(item.attrs);
              //如果傳來的文字物件沒有寬度就給200
              if (!item.attrs?.width || !item.attrs?.height) {
                text.width(200);
                text.height(200);
              }
              text.x(text.x() * that.coworkBgRatio);
              text.y(text.y() * that.coworkBgRatio);
              label.add(text);
            }
          });
          that.layer.add(label);
          that.layer.batchDraw();
        }
        if (JsonItem.className == "Group") {
          //作品收集圖，挑人名單標籤
          let group = new Konva.Group(JsonItem.attrs);
          group.setAttrs({
            index: parseInt(key),
          });

          JsonItem.children.forEach((item) => {
            let normalClassName = ["Line", "Circle", "Rect", "Star", "Text", "Path", "Ellipse", "RegularPolygon"];
            if (normalClassName.includes(item.className)) {
              let addItem = new Konva[item.className]({
                parent: group,
                ...item.attrs,
              });
              group.add(addItem);
            }
            if (item.className == "Image") {
              //快速複製時可能不同步
              if ((vm.blobSas_read == undefined && vm.mobileirs.hostmode != "CC") || (vm.blobSas_read == "" && vm.mobileirs.hostmode != "CC")) vm.blobSas_read = vm.blobSasRead;
              let finallink = item.attrs.src.includes(that.blobSas_read) || item.attrs?.fromLocal ? item.attrs.src : item.attrs.src + "?" + that.blobSas_read;
             
              if (item.attrs?.name === 'OpenClipArt') {
                // 将 URL 的域名部分替换为本地路径
                const finallinkParts = finallink.split('/'); // 分割 URL
                finallinkParts[2] = window.location.host;   // 替换域名部分为当前页面的主机
                const replace = finallinkParts.join('/');   // 重新拼接 URL
                finallink = replace
              }
             
              Konva.Image.fromURL(finallink, async function(image) {
                //console.log(item.attrs)
                await image.setAttrs({
                  parent: group,
                  ...item.attrs,
                });

                await group.add(image);
                await that.layer.batchDraw();
                //  console.log(group,'目前的群組內容')
                await that.layer.add(group);
                await that.layer.batchDraw();
              });
            }
          });
          //Cowork縮放
          group.x(group.x() * that.coworkBgRatio);
          group.y(group.y() * that.coworkBgRatio);
          group.scaleX(group.scaleX() * that.coworkBgRatio);
          group.scaleY(group.scaleY() * that.coworkBgRatio);
          await that.layer.add(group);
          await that.layer.batchDraw();
        }

        if (JsonItem.className == "Image") {
          that.addKonvaSingleImg(JsonItem, that.layer);
        }
        if (KonvaItem) {
          that.layer.add(KonvaItem);
        }
      }

      setTimeout(() => {
        vm.layer.children.sort(function(a, b) {
          let indexA = a.attrs.index;
          let indexB = b.attrs.index;
          if (indexA < indexB) {
            return -1;
          }
          if (indexA > indexB) {
            return 1;
          }
          return 0;
        });
        vm.layer.children.forEach((item) => {
          if (item.attrs.name == "bgRect") {
            item.moveToBottom();
          }
        });
        vm.layer.batchDraw();
        vm.isWaitingStopReplayRefresh = false;
      }, 500);

      console.log("已渲染");
    }
  },

  async updateStageObj(vm, targetAction, waiting = false, replay = false) {
    console.log("單一物件渲染!", targetAction);
    // console.log(JSON.parse(targetAction.item).attrs.name,"namelabel")

    vm.removeNameLabel();
    vm.currentEditor.seat = targetAction?.fromInfo?.seat ? targetAction?.fromInfo?.seat : "";
    vm.currentEditor.name = targetAction?.fromInfo?.name ? targetAction?.fromInfo?.name : "";

    let that = vm;
    let targetItem = "";
    let childrenIndex = -1;
    if (targetAction.action != "screenNormal" && targetAction.action != "screenLarge") {
      targetItem = typeof targetAction.item === "object" ? targetAction.item : JSON.parse(targetAction.item);
      childrenIndex = vm.layer.children.findIndex((x) => x.attrs.uuid == targetItem.attrs.uuid);
    }
    if (targetAction.action == "add") {
      let normalClassName = ["Line", "Circle", "Rect", "Star", "Text", "Path", "Ellipse", "RegularPolygon"];
      if (normalClassName.includes(JSON.parse(targetAction.item).className)) {
        let KonvaItem = new Konva[JSON.parse(targetAction.item).className](JSON.parse(targetAction.item).attrs);
        if (JSON.parse(targetAction.item).className == "Text") {
          if (!JSON.parse(targetAction.item).attrs?.width) {
            KonvaItem.width(300);
          }
        }
        //Cowork縮放
        KonvaItem.x(KonvaItem.x() * that.coworkBgRatio);
        KonvaItem.y(KonvaItem.y() * that.coworkBgRatio);
        KonvaItem.scaleX(KonvaItem.scaleX() * that.coworkBgRatio);
        KonvaItem.scaleY(KonvaItem.scaleY() * that.coworkBgRatio);

        vm.layer.add(KonvaItem);
        if (JSON.parse(targetAction.item).className == "Rect" && KonvaItem.attrs.name == "bgRect") {
          KonvaItem.moveToBottom();
        }

        vm.layer.batchDraw();
      } else if (JSON.parse(targetAction.item).className == "Label" && JSON.parse(targetAction.item).attrs.name != "namelabel") {
        //文字便利貼

        let label = new Konva.Label(JSON.parse(targetAction.item).attrs);
        JSON.parse(targetAction.item).children.forEach((item) => {
          if (item.className == "Tag") {
            let tag = new Konva.Tag(item.attrs);
            //Cowork縮放
            tag.x(tag.x() * that.coworkBgRatio);
            tag.y(tag.y() * that.coworkBgRatio);
            // tag.scaleX(that.coworkBgRatio)
            // tag.scaleY(that.coworkBgRatio)
            label.add(tag);
          }
          if (item.className == "Text") {
            let text = new Konva.Text(item.attrs);
            //如果傳來的文字物件沒有寬度就給200
            if (!item.attrs?.width || !item.attrs?.height) {
              text.width(200);
              text.height(200);
            }

            //Cowork縮放
            text.x(text.x() * that.coworkBgRatio);
            text.y(text.y() * that.coworkBgRatio);
            // text.scaleX(that.coworkBgRatio)
            // text.scaleY(that.coworkBgRatio)
            label.add(text);
          }
        });

        //Cowork縮放
        label.x(label.x() * that.coworkBgRatio);
        label.y(label.y() * that.coworkBgRatio);
        label.scaleX(label.scaleX() * that.coworkBgRatio);
        label.scaleY(label.scaleY() * that.coworkBgRatio);

        vm.layer.add(label);
        vm.layer.batchDraw();
      } else if (JSON.parse(targetAction.item).className == "Image") {
        await vm.addKonvaSingleImg(JSON.parse(targetAction.item), vm.layer);
      } else if (JSON.parse(targetAction.item).className == "Group") {
        let KonvaGroup = new Konva[JSON.parse(targetAction.item).className](JSON.parse(targetAction.item).attrs);

        JSON.parse(targetAction.item).children.forEach((child) => {
          let normalClassName = ["Line", "Circle", "Rect", "Star", "Text", "Path", "Ellipse", "RegularPolygon"];
          if (normalClassName.includes(child.className)) {
            let item = new Konva[child.className]({
              parent: KonvaGroup,
              ...child.attrs,
            });
            //Cowork縮放
            item.x(item.x() * that.coworkBgRatio);
            item.y(item.y() * that.coworkBgRatio);
            item.scaleX(item.scaleX() * that.coworkBgRatio);
            item.scaleY(item.scaleY() * that.coworkBgRatio);
            KonvaGroup.add(item);
          }
          if (child.className == "Image") {
            vm.addKonvaSingleImg(child, KonvaGroup);
          }
        });
        //Cowork縮放
        KonvaGroup.x(KonvaGroup.x() * that.coworkBgRatio);
        KonvaGroup.y(KonvaGroup.y() * that.coworkBgRatio);
        vm.layer.add(KonvaGroup);
        vm.layer.batchDraw();
      }
    } else if (targetAction.action == "update") {
      let timeout = 0;

      if (waiting) timeout = 1500;

      setTimeout(() => {
        let targetSize = typeof targetAction.size === "object" ? targetAction.size : JSON.parse(targetAction.size);
        let itemWidth, itemHeight;

        itemWidth = targetSize ? targetSize.width : itemWidth;
        itemHeight = targetSize ? targetSize.height : itemHeight;

        console.log(itemWidth, itemHeight);
        let result = that.calScaleRatio(itemWidth, itemHeight, window.innerWidth, window.innerHeight);
        that.coworkBgRatio = result.ratio ? result.ratio : 1;

        childrenIndex = vm.layer.children.findIndex((x) => x.attrs.uuid == targetItem.attrs.uuid);
        console.log("更新物件", targetAction.fromInfo, childrenIndex);

        if (childrenIndex != -1) {
          vm.layer.children[childrenIndex].setAttrs(targetItem.attrs);

          if (!targetItem.attrs.hasOwnProperty("x")) vm.layer.children[childrenIndex].setAttrs({ x: 0 });
          if (!targetItem.attrs.hasOwnProperty("y")) vm.layer.children[childrenIndex].setAttrs({ y: 0 });
          if (!targetItem.attrs.hasOwnProperty("rotation")) vm.layer.children[childrenIndex].setAttrs({ rotation: 0 });
          if (!targetItem.attrs.hasOwnProperty("scaleX")) vm.layer.children[childrenIndex].setAttrs({ scaleX: 1 });
          if (!targetItem.attrs.hasOwnProperty("scaleY")) vm.layer.children[childrenIndex].setAttrs({ scaleY: 1 });

          //Cowork縮放
          vm.layer.children[childrenIndex].x(vm.layer.children[childrenIndex].x() * vm.coworkBgRatio);
          vm.layer.children[childrenIndex].y(vm.layer.children[childrenIndex].y() * vm.coworkBgRatio);
          vm.layer.children[childrenIndex].scaleX(vm.layer.children[childrenIndex].scaleX() * vm.coworkBgRatio);
          vm.layer.children[childrenIndex].scaleY(vm.layer.children[childrenIndex].scaleY() * vm.coworkBgRatio);

          if (vm.layer.children[childrenIndex].className == "Label" || vm.layer.children[childrenIndex].className == "Group") {
            vm.layer.children[childrenIndex].children.forEach((item, i) => {
              item.setAttrs(targetItem.children[i].attrs);
            });
          }
          if (replay) {
            // console.log(that.finalStageRatio,"that.finalStageRatio")
            if (vm.layer.children[childrenIndex].attrs.name == "HtexGroup") {
              vm.layer.children[childrenIndex].offsetX(vm.layer.children[childrenIndex].offsetX() * that.finalStageRatio);
              vm.layer.children[childrenIndex].offsetY(vm.layer.children[childrenIndex].offsetY() * that.finalStageRatio);
              vm.layer.children[childrenIndex].scaleX(vm.layer.children[childrenIndex].scaleX() / that.finalStageRatio);
              vm.layer.children[childrenIndex].scaleY(vm.layer.children[childrenIndex].scaleY() / that.finalStageRatio);
            }
          }

          if (!vm.isSelectTouchingNow) {
            //touch觸控不立刻渲染白板
            vm.layer.batchDraw();
          }
        }
      }, timeout);

      //複合物件點擊目標待修
    } else if (targetAction.action == "delete") {
      setTimeout(() => {
        childrenIndex = vm.layer.children.findIndex((x) => x.attrs.uuid == targetItem.attrs.uuid);
        if (childrenIndex != -1) {
          vm.layer.children[childrenIndex].remove();
          vm.layer.draw();
        }
      }, 100);
    } else if (targetAction.action == "backZIndex") {
      if (childrenIndex != -1) {
        vm.layer.children[childrenIndex].zIndex(targetAction.Index);
        vm.layer.batchDraw();
      }
    } else if (targetAction.action == "moveToTop") {
      if (childrenIndex != -1) {
        vm.layer.children[childrenIndex].setAttrs({
          index: vm.layer.children.length,
        });
      }
    } else if (targetAction.action == "moveToBottom") {
      if (childrenIndex != -1) {
        vm.layer.children[childrenIndex].setAttrs({
          index: 0,
        });
      }
    } else if (targetAction.action == "screenNormal" || targetAction.action == "screenLarge") {
      //重播htexGroup會用到縮放
      that.finalStageRatio = targetAction?.currentStageScale ? targetAction?.currentStageScale : that.finalStageRatio;
      console.log(that.finalStageRatio, "that.finalStageRatio");
    } else if (targetAction.action == "undoDelete") {
      console.log("undoDelete重播");
      this.recoverStageObj(vm,targetAction);
    }

    if (targetAction.position && vm.showNameLabel) {
      const label = new Konva.Label({
        x: targetAction.position.x * that.coworkBgRatio, // X坐标
        y: targetAction.position.y * that.coworkBgRatio, // Y坐标
        name: "namelabel",
      });

      // 创建一个Konva.Tag作为标签
      const tag = new Konva.Tag({
        fill: "black", // 标签背景颜色
        name: "namelabel",
      });

      // 将标签添加到Label中
      label.add(tag);

      // 创建一个Konva.Text作为标签上的文本
      const text = new Konva.Text({
        text: targetAction.fromInfo.seat + targetAction.fromInfo.name,
        fontSize: 16,
        fill: "white", // 文本颜色
        padding: 5, // 文本内边距
        name: "namelabel",
      });

      //将文本添加到Label中
      label.add(text);
      vm.layer.add(label);
    }
  },

  addShape(vm) {
    let that = vm;
    vm.toggleBtnOn = "shape";

    vm.removeStageEvents();
    vm.removeTextTransformer();
    vm.setGroupChildDraggable(false);
    let stage = vm.stage;
    let layer = vm.layer;
    let shapeType = vm.shapeType;
    let shapeBorderColor = vm.shapeBorderColor;
    let shapeColor = vm.shapeColor;
    let rect; // 各种图形的容器
    let currentArrow;
    let start = [];
    let end = []; // 记录绘制图形的起始点坐标、结束点坐标
    let lastClientX;
    let lastClientY;
    let beginClientX;
    let beginClientY;

    const pos = stage.getPointerPosition();

    vm.stage.on("mouseup touchend", (e) => {
      that.isPaint = false;

      //儲存undo歷史
      vm.undoHistory.push({
        action: "delete",
        item: JSON.parse(JSON.stringify(layer.children[layer.children.length - 1])),
      });
      //新增前一動應提供該物件的初始化Attr
      vm.undoHistory.push({
        action: "update",
        item: JSON.parse(JSON.stringify(layer.children[layer.children.length - 1])),
      });
      vm.isModified = true;
      if (vm.mobileirs.IRSmode == "Cowork") {
        vm.isSendByMe = true;
        if (vm.mobileirs.hostmode == "CC") {
          // vm.mobileirs.IMSendMsg(0, { action: 'add', item: layer.children[layer.children.length - 1] }, 28)
        } else {
          let uuid = layer.children[layer.children.length - 1].attrs.uuid;
          let position = vm.stage.getPointerPosition();
          vm.sendItemToHTWb(position, uuid, "add", that.layer.children[that.layer.children.length - 1],'draw');
          // vm.mobileirs.IMSendMsg(0, { action: 'add', item: layer.children[layer.children.length - 1] }, 25) //發物件給全部WebIRS
          // vm.mobileirs.IMSendMsg(0, { action: 'add', item: htexItem }, 26)
        }
      }
      if (e.type == "touchend") {
        lastClientX = stage.getPointerPosition().x;
        lastClientY = stage.getPointerPosition().y;
      } else {
        lastClientX = e.evt.offsetX;
        lastClientY = e.evt.offsetY;
      }

      start = [];
      end = [];
    });
    vm.stage.on("mousedown touchstart", (e) => {
      that.removeTargetEvents(e.target);
      that.hideAllMenu();
      that.isPaint = true;
      that.layer.children.forEach((item) => {
        item.draggable(false);
      });
      let currentIndex = that.layer?.children ? JSON.parse(JSON.stringify(that.layer?.children)).length - 1 : 1;
      if (shapeType == "line") {
        // 直线
        rect = new Konva.Line({
          uuid: htkv.genUUID(),
          fill: shapeBorderColor,
          stroke: shapeBorderColor,
          strokeWidth: 5,
          hitStrokeWidth: 30,
          closed: true,
          globalCompositeOperation: "source-over",
          points: [that.getRelativePointerPosition(stage).x, that.getRelativePointerPosition(stage).y],
          name: "line",
          lineCap: "round",
          lineJoin: "round",
          index: currentIndex,
        });
        layer.add(rect);
      } else if (shapeType == "long-arrow-alt-right") {
        const scale = that.currentScale;
        const originalPoints = [0, 0, 6.25695, -22.371525, 6.25695, -22.371525, 13.6, -19.2, 0, -38.4, -13.6, -19.2, -6.25695, -22.371525];
        const scaledPoints = originalPoints.map((point) => point * scale);
        currentArrow = new Konva.Line({
          name: "arrowLine",
          uuid: htkv.genUUID(),
          x: that.getRelativePointerPosition(stage).x,
          y: that.getRelativePointerPosition(stage).y,
          rotation: 180,
          offsetX: 0,
          offsetY: 0,
          // points: [0, 0, 3.25695, -22.371525, 3.25695, -22.371525, 9.6, -19.2, 0, -38.4, -9.6, -19.2, -3.25695, -22.371525],
          points: scaledPoints,
          // fill: 'red',
          fill: shapeBorderColor,
          stroke: shapeBorderColor,
          strokeWidth: 1,
          hitStrokeWidth: 30,
          shadowBlur: 0,
          closed: true,
          lineCap: "round",
          lineJoin: "round",
          name: "arrowline",
          draggable: true,
          index: that.layer?.children ? that.layer?.children.length : 1,
        });
      } else if (shapeType == "square") {
        // 矩形
        rect = new Konva.Rect({
          uuid: htkv.genUUID(),
          x: that.getRelativePointerPosition(stage).x - 10,
          y: that.getRelativePointerPosition(stage).y - 10,
          width: 10,
          height: 10,
          fill: shapeColor,
          stroke: shapeBorderColor,
          strokeWidth: 4,
          name: "rect",
          index: that.layer?.children ? that.layer?.children.length : 1,
        });
      } else if (shapeType == "circle") {
        // 正圆
        rect = new Konva.Circle({
          uuid: htkv.genUUID(),
          x: that.getRelativePointerPosition(stage).x - 5,
          y: that.getRelativePointerPosition(stage).y - 5,
          // radius: 50,
          radius: 5,
          fill: shapeColor,
          stroke: shapeBorderColor,
          strokeWidth: 4,
          name: "circle",
          index: that.layer?.children ? that.layer?.children.length : 1,
        });
      } else if (shapeType == "ellipse") {
        // 椭圆
        rect = new Konva.Ellipse({
          uuid: htkv.genUUID(),
          x: that.getRelativePointerPosition(stage).x - 5,
          y: that.getRelativePointerPosition(stage).y - 5,
          // radius: 50,
          radiusX: 5,
          radiusY: 5,
          fill: shapeColor,
          stroke: shapeBorderColor,
          strokeWidth: 4,
          name: "ellipse",
          index: that.layer?.children ? that.layer?.children.length : 1,
        });
      } else if (shapeType == "campground") {
        // 三角形
        rect = new Konva.RegularPolygon({
          uuid: htkv.genUUID(),
          x: that.getRelativePointerPosition(stage).x - 10,
          y: that.getRelativePointerPosition(stage).y - 5,
          sides: 3,
          radius: 10,
          fill: shapeColor,
          stroke: shapeBorderColor,
          strokeWidth: 4,
          name: "campground",
          index: currentIndex,
        });
      } else if (shapeType == "star") {
        // 五角星
        rect = new Konva.Star({
          uuid: htkv.genUUID(),
          x: that.getRelativePointerPosition(stage).x - 7,
          y: that.getRelativePointerPosition(stage).y - 7,
          numPoints: 5,
          innerRadius: 4,
          outerRadius: 8,
          fill: shapeColor,
          stroke: shapeBorderColor,
          strokeWidth: 4,
          name: "star",
          index: currentIndex,
        });
      }

      layer.draw();
    });
    stage.on("mousemove touchmove", function(e) {
      // 直线的
      if (!that.isPaint) {
        return;
      }
      const pos = stage.getPointerPosition();
      let onex = that.getRelativePointerPosition(stage).x;
      let oney = that.getRelativePointerPosition(stage).y;
      let newPoints = [];

      if (shapeType == "long-arrow-alt-right") {
        const newPoints = currentArrow.points();
        const deltaX = that.getRelativePointerPosition(stage).x - currentArrow.x();
        const deltaY = that.getRelativePointerPosition(stage).y - currentArrow.y();

        let newArrowHeight = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
        if (newArrowHeight < 38.4) newArrowHeight = 38.4;
        const newRotation = (Math.atan2(deltaX, -deltaY) * 180) / Math.PI;
        newPoints[1] = newArrowHeight - 38.4;
        currentArrow.offsetY(newArrowHeight - 38.4);
        currentArrow.points(newPoints);
        currentArrow.rotation(newRotation);
        layer.add(currentArrow);
        layer.batchDraw();
      }
      document.body.classList.remove("cursor-fdj");
      if (!rect) {
        return;
      }
      let name = rect.attrs.name;
      if (name == "line") {
        let newPoints;
        if (shapeType == "line") {
          if (rect.points().length > 4) {
            newPoints = rect
              .points()
              .slice(0, 2)
              .concat([that.getRelativePointerPosition(stage).x, that.getRelativePointerPosition(stage).y]);
          } else {
            newPoints = rect.points().concat([that.getRelativePointerPosition(stage).x, that.getRelativePointerPosition(stage).y]);
          }
        }
        rect.points(newPoints);
      } else if (name == "rect") {
        // 矩形
        if (start.length < 1) {
          start = [pos.x + 10, pos.y + 10];
        }
        let newPoints = end.concat([pos.x + 10, pos.y + 10]).slice(-2);

        rect.width(newPoints[0] - start[0] + 10);
        rect.height(newPoints[1] - start[1] + 10);
      } else if (name === "circle") {
        // 正圆
        if (start.length < 1) {
          start = [pos.x + 5, pos.y + 5];
        }
        let newPoints = end.concat([pos.x + 5, pos.y + 5]).slice(-2);
        let radiusX = newPoints[0] - start[0] + 5;
        let radiusY = newPoints[1] - start[1] + 5;

        if (radiusX < 10 || radiusY < 10) {
          return;
        }
        rect.radius(newPoints[0] - start[0] + 5);
        // rect.radiusY(newPoints[1] - start[1] + 5);
      } else if (name === "ellipse") {
        // 椭圆
        if (start.length < 1) {
          start = [pos.x + 5, pos.y + 5];
        }
        let newPoints = end.concat([pos.x + 5, pos.y + 5]).slice(-2);
        let radiusX = newPoints[0] - start[0] + 5;
        let radiusY = newPoints[1] - start[1] + 5;
        if (radiusX < 10 || radiusY < 10) {
          return;
        }
        rect.radiusX(newPoints[0] - start[0] + 5);
        rect.radiusY(newPoints[1] - start[1] + 5);
      } else if (name == "campground") {
        // 三角形&多边形
        if (start.length < 1) {
          start = [pos.x - 10, pos.y - 5];
        }
        let newPoints = end.concat([pos.x, pos.y]).slice(-2);
        let radiusX = newPoints[0] - start[0] + 5;
        rect.radius(newPoints[0] - start[0]);
      } else if (name == "star") {
        // 五角星
        if (start.length < 1) {
          start = [pos.x - 4, pos.y - 4];
        }
        let newPoints = end.concat([pos.x, pos.y]).slice(-2);
        rect.innerRadius(newPoints[0] - start[0]);
        rect.outerRadius((newPoints[0] - start[0]) * 2);
      }
      layer.add(rect);
      layer.draw();
    });
  },
  setZoomSize(vm, value, event) {
    vm.zoomSize = value;
    let that = vm;
    let stage = vm.stage;
    let layer = vm.layer;
    for (let i = 0; i < layer.children.length; i++) {
      layer.children[i].draggable(false);
    }

    let zoom = vm.zoomSize;
    // console.log(zoom, '缩放工具')
    let oldScale = stage.scaleX();
    //Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event)
    if (event?.touches) {
      stage.setPointersPositions(event);
    }

    let pointer = stage.getPointerPosition();

    if (pointer && vm.zoomType == "click") {
      let mousePointTo = {
        x: (pointer.x - stage.x()) / oldScale,
        y: (pointer.y - stage.y()) / oldScale,
      };
      let newPos = {
        x: pointer.x - mousePointTo.x * zoom * vm.relativScaleRatio.ratio,
        y: pointer.y - mousePointTo.y * zoom * vm.relativScaleRatio.ratio,
      };
      stage.position(newPos);
    } else {
      stage.absolutePosition({
        x: (-stage.width() / 2) * (zoom - 1),
        y: (-stage.height() / 2) * (zoom - 1) - vm.relativScaleRatio.screenOffsetY * zoom,
      });
      stage.position({
        x: (-stage.width() / 2) * (zoom - 1),
        y: (-stage.height() / 2) * (zoom - 1) - vm.relativScaleRatio.screenOffsetY * zoom,
      });
    }
    stage.scale({
      x: zoom * vm.relativScaleRatio.ratio,
      y: zoom * vm.relativScaleRatio.ratio,
    });

    if (zoom == 1) {
      vm.stage.setAttrs({
        y: -vm.relativScaleRatio.screenOffsetY,
        scaleX: vm.relativScaleRatio.ratio,
        scaleY: vm.relativScaleRatio.ratio,
      });
    }
    setTimeout(() => {
      vm.layer.children.forEach((item) => {
        if (item.attrs.name == "bgRect") {
          item.setAttrs({
            x: 0,
            y: +vm.relativScaleRatio.screenOffsetY / vm.relativScaleRatio.ratio,
            draggable: false,
          });
        }
      });
      vm.layer.batchDraw();
    });
  },
  recoverStageObj(vm, targetAction) {
    // scale需乘以目前倍率,與原本的updateStageObj之差異

    vm.stage.find("Label").forEach((obj) => {
      if (obj.attrs.name == "namelabel") {
        obj.remove();
      }
    });

    vm.currentEditor.seat = targetAction?.fromInfo?.seat ? targetAction?.fromInfo?.seat : "";
    vm.currentEditor.name = targetAction?.fromInfo?.name ? targetAction?.fromInfo?.name : "";

    let that = vm;
    let normalClassName = ["Line", "Circle", "Rect", "Star", "Text", "Path", "Ellipse", "RegularPolygon"];
    if (normalClassName.includes(JSON.parse(targetAction.item).className)) {
      let KonvaItem = new Konva[JSON.parse(targetAction.item).className](JSON.parse(targetAction.item).attrs);

      //如果傳來的文字物件沒有寬度就給300
      if (JSON.parse(targetAction.item).className == "Text") {
        if (!JSON.parse(targetAction.item).attrs?.width) {
          KonvaItem.width(300);
        }
      }
      //Cowork縮放
      KonvaItem.x(KonvaItem.x() * that.coworkBgRatio);
      KonvaItem.y(KonvaItem.y() * that.coworkBgRatio);
      KonvaItem.scaleX(KonvaItem.scaleX() * that.coworkBgRatio);
      KonvaItem.scaleY(KonvaItem.scaleY() * that.coworkBgRatio);

      vm.layer.add(KonvaItem);
      if (JSON.parse(targetAction.item).className == "Rect" && KonvaItem.attrs.name == "bgRect") {
        KonvaItem.moveToBottom();
      }

      vm.layer.batchDraw();
    } else if (JSON.parse(targetAction.item).className == "Label") {
      //文字便利貼
      let label = new Konva.Label(JSON.parse(targetAction.item).attrs);
      JSON.parse(targetAction.item).children.forEach((item) => {
        if (item.className == "Tag") {
          let tag = new Konva.Tag(item.attrs);
          //Cowork縮放
          tag.x(tag.x() * that.coworkBgRatio);
          tag.y(tag.y() * that.coworkBgRatio);
          // tag.scaleX(that.coworkBgRatio)
          // tag.scaleY(that.coworkBgRatio)
          label.add(tag);
        }
        if (item.className == "Text") {
          let text = new Konva.Text(item.attrs);
          //如果傳來的文字物件沒有寬度就給200
          if (!item.attrs?.width || !item.attrs?.height) {
            text.width(200);
            text.height(200);
          }
          //Cowork縮放
          text.x(text.x() * that.coworkBgRatio);
          text.y(text.y() * that.coworkBgRatio);
          // text.scaleX(that.coworkBgRatio)
          // text.scaleY(that.coworkBgRatio)
          label.add(text);
        }
      });

      //Cowork縮放
      label.x(label.x() * that.coworkBgRatio);
      label.y(label.y() * that.coworkBgRatio);
      label.scaleX(label.scaleX() * that.coworkBgRatio);
      label.scaleY(label.scaleY() * that.coworkBgRatio);

      vm.layer.add(label);
      vm.layer.batchDraw();
    } else if (JSON.parse(targetAction.item).className == "Image") {
      vm.addKonvaSingleImg(JSON.parse(targetAction.item), vm.layer, true);
    } else if (JSON.parse(targetAction.item).className == "Group") {
      let KonvaGroup = new Konva[JSON.parse(targetAction.item).className](JSON.parse(targetAction.item).attrs);

      JSON.parse(targetAction.item).children.forEach((child) => {
        let normalClassName = ["Line", "Circle", "Rect", "Star", "Text", "Path", "Ellipse", "RegularPolygon"];
        if (normalClassName.includes(child.className)) {
          let item = new Konva[child.className]({
            parent: KonvaGroup,
            ...child.attrs,
          });
          //Cowork縮放
          item.x(item.x() * that.coworkBgRatio);
          item.y(item.y() * that.coworkBgRatio);
          item.scaleX(item.scaleX() * that.coworkBgRatio);
          item.scaleY(item.scaleY() * that.coworkBgRatio);
          KonvaGroup.add(item);
        }
        if (child.className == "Image") {
          vm.addKonvaSingleImg(child, KonvaGroup, true);
        }
      });
      //Cowork縮放
      KonvaGroup.x(KonvaGroup.x() * that.coworkBgRatio);
      KonvaGroup.y(KonvaGroup.y() * that.coworkBgRatio);
      vm.layer.add(KonvaGroup);
      vm.layer.batchDraw();
    }
    if (targetAction.position && vm.showNameLabel) {
      const label = new Konva.Label({
        x: targetAction.position.x * that.coworkBgRatio, // X坐标
        y: targetAction.position.y * that.coworkBgRatio, // Y坐标
        name: "namelabel",
      });

      // 创建一个Konva.Tag作为标签
      const tag = new Konva.Tag({
        fill: "black", // 标签背景颜色
        name: "namelabel",
      });

      // 将标签添加到Label中
      label.add(tag);

      // 创建一个Konva.Text作为标签上的文本
      const text = new Konva.Text({
        text: targetAction.fromInfo.seat + targetAction.fromInfo.name,
        fontSize: 16,
        fill: "white", // 文本颜色
        padding: 5, // 文本内边距
        name: "namelabel",
      });

      //将文本添加到Label中
      label.add(text);
      vm.layer.add(label);
    }
  },
  replayAction(vm, index) {
    let that = vm;
    vm.currentReplayIndex = index;
    if (index < vm.currentReplayHistory.length) {
      let item = vm.currentReplayHistory[index];
      let itemWidth = JSON.parse(item).size.width ? JSON.parse(item).size.width : JSON.parse(JSON.parse(item).size.replace(/\r\n/g, "")).width;
      let itemHeight = JSON.parse(item).size.height ? JSON.parse(item).size.height : JSON.parse(JSON.parse(item).size.replace(/\r\n/g, "")).height;

      let result = that.calScaleRatio(itemWidth, itemHeight, window.innerWidth, window.innerHeight);
      console.log(itemWidth, itemHeight, window.innerWidth, window.innerHeight)
      vm.coworkBgRatio = result.ratio ? result.ratio : 1;

      if (JSON.parse(item).action !== "sizeWb") {
        vm.updateStageObj(JSON.parse(item), false, true);

        vm.replayTimeoutId = setTimeout(() => {
          that.replayAction(index + 1);
        }, 800 / (that.replayFastMode ? 2 : 1));
      }
    } else {
      vm.isCoworkReplay = false;
      vm.sendReplayDonetoHTWb();
      setTimeout(() => {
        that.removeNameLabel();
      }, 300);
    }
  },
  doUndoInCowork(vm) {
    //僅針對刪除物件做還原
    if (vm.undoDeleteHistory == "") {
      alert(vm.$t('webirs.konvaCanvas["目前沒有動作可復原"]'));
      return;
    }
    vm.removeTransformer();
    vm.removeTextTransformer();
    if (vm.undoDeleteHistory != "") {
      vm.coworkBgRatio = 1;
      let position = vm.stage.getPointerPosition();
      let uuid = JSON.parse(vm.undoDeleteHistory[vm.undoDeleteHistory.length - 1].item).attrs.uuid;
      let item = vm.undoDeleteHistory[vm.undoDeleteHistory.length - 1].item;
      vm.finalCoworkAction = { uuid: uuid, action: "undoDelete" };
      vm.sendItemToHTWb(position, uuid, "undoDelete", item,'undoDelete');
      this.recoverStageObj(vm, vm.undoDeleteHistory[vm.undoDeleteHistory.length - 1]);
    }
    vm.undoDeleteHistory.pop();
    vm.$Message.info(vm.$t('webirs.konvaCanvas["復原我最近一次刪除動作"]'));
  },
};
